import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/warehouse/sites',
}).lazy(() => import('./sites.lazy').then((d) => d.Route))
